var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "section sub-visual-office"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "line-height-1",
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h2', {
    staticClass: "font-size-32 font-size-md-46 font-size-lg-56 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.sh))])]), _c('v-spacer'), _c('v-col', {
    staticClass: "d-flex align-center font-size-12 font-size-lg-14 color-grey-7",
    attrs: {
      "cols": "auto"
    }
  }, [_c('p', [_vm._v("기업소개")]), _c('i', {
    staticClass: "icon icon-right-arrow-sm mx-6 mx-lg-16"
  }), _c('p', {
    staticClass: "font-weight-bold color-black"
  }, [_vm._v(_vm._s(_vm.sh))])])], 1), _c('div', {
    staticClass: "sub-visual-office--bg mt-50 mt-lg-80",
    style: 'background-image:url(' + _vm.bg + ');'
  }), _c('div', {
    staticClass: "sub-visual-office--detail mt-30 mt-lg-54"
  }, [_vm._t("default")], 2)], 1), _c('router-link', {
    staticClass: "link-box mt-30 mt-lg-0",
    attrs: {
      "to": _vm.link
    }
  }, [_c('div', {
    staticClass: "w-100 w-lg-260px h-lg-260px py-20 py-md-30 py-lg-34 px-12 px-lg-32 color-white d-flex flex-column align-center align-lg-start justify-space-between text-center text-lg-left"
  }, [_c('h6', {
    staticClass: "font-size-18 font-size-lg-22 font-weight-bold"
  }, [_vm._v(" 세일즈웍스의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" " + _vm._s(_vm.linkText) + " ")]), _c('div', {
    staticClass: "d-flex align-center mt-6 mt-lg-0"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-1"
  }, [_vm._v(" " + _vm._s(_vm.shRe) + "안내 ")]), _c('i', {
    staticClass: "icon icon-right-arrow-w ml-6 ml-lg-16"
  })])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }